module.exports = __webpack_public_path__ + "static/Orthotic appliance-cf76d9e61d9b37243dd68debbeb3a9e7.jpg";